<template>
    <bs5-base-button variant="secondary" size="sm">
        Cancel
    </bs5-base-button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "CancelButton",
});
</script>